<form [formGroup]="form" (ngSubmit)="onSave()">
	@if (httpError == '400') {
		<mat-error class="top-right-absolute-error-message">
			{{ 'mes.administration.batch.shared.errors.bad-request' | translate }}
		</mat-error>
	}
	@if (httpError == '500') {
		<mat-error class="top-right-absolute-error-message">
			{{ 'mes.administration.batch.shared.errors.internal-server-error' | translate }}
		</mat-error>
	}

	<h1 mat-dialog-title class="notification-title no-select">
		{{ 'mes.administration.batch.dialog.create-batch' | translate }}
	</h1>

	<mat-dialog-content style="padding-top: 20px">
		<div class="optional-form-fields">
			@if (httpError == '409') {
				<mat-error>
					{{ 'mes.administration.batch.shared.errors.duplicate' | translate }}
				</mat-error>
			}
			@if (controls['alias'].invalid && controls['alias'].touched) {
				<mat-error>
					{{ 'mes.administration.batch.shared.errors.empty-or-invalid-characters-error' | translate }}
				</mat-error>
			}
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'mes.administration.batch.shared.alias' | translate }}
				</mat-label>
				<input maxlength="255" matInput formControlName="alias" />
			</mat-form-field>

			@if (controls['name'].invalid && controls['name'].touched) {
				<mat-error>
					{{ 'mes.administration.batch.shared.errors.invalid-characters-error' | translate }}
				</mat-error>
			}
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'mes.administration.batch.shared.name' | translate }}
				</mat-label>
				<input maxlength="255" matInput formControlName="name" />
			</mat-form-field>
		</div>
	</mat-dialog-content>
	<div>
		<div mat-dialog-actions align="end">
			<button mat-flat-button color="primary" type="submit" [disabled]="loading || form.invalid">
				{{ 'mes.administration.batch.shared.okbtn' | translate }}
			</button>
			<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">
				{{ 'mes.administration.batch.shared.cancelbtn' | translate }}
			</button>
		</div>
	</div>
</form>
